module.exports = __webpack_public_path__ + "assets/img/result_en.06abcb34.png";